// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2P69g","content":"styles_content__23Gk_","selectAll":"styles_selectAll__eFK9-"};